var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgTextBalloon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 106,
    height: 43,
    fill: "none",
    viewBox: "0 0 106 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#53E3AC",
    fillRule: "evenodd",
    d: "M20.88 0C9.348 0 0 9.348 0 20.88c0 5.133 1.852 9.834 4.925 13.47l-3.018 7.243c-.348.835.48 1.677 1.3 1.323l8.072-3.49c2.874 1.492 6.14 2.334 9.601 2.334h64.24c11.532 0 20.88-9.348 20.88-20.88C106 9.348 96.652 0 85.12 0H20.88z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.482 12.628h9.6v2.42h-3.78c-.04 1.5-.14 2.94-.36 4.32 1.04 2.96 2.84 5.86 5.14 7.92l-2.04 1.68c-1.6-1.56-2.98-3.58-4.02-5.64-.68 2.1-1.66 4.04-2.94 5.78l-2.36-1.28c2.74-3.74 3.86-7.64 3.94-12.78h-3.18v-2.42zm14.94-.28v17.28h-2.64v-17.28h2.64zm2.407 6.72h16.54v2.34H30.83v-2.34zm15.7-.8h-2.66v-3.22h-12.2v-2.42h14.86v5.64zm0 4.54v6.72H31.67v-6.72h14.86zm-12.2 4.46h9.54v-2.2h-9.54v2.2zm28.775-14.64v16.24h-8.9v-16.24h2.56v5.16h3.78v-5.16h2.56zm5.68 8.76v8.24h-2.66v-17.28h2.66v6.5h2.24v2.54h-2.24zm-12.02 5.08h3.78v-6.24h-3.78v6.24zm30.668-5.32v2.3h-15.04v-6.6h12.2v-1.92h-12.2v-2.3h14.86v6.48h-12.2v2.04h12.38zm.66 5.4v2.42h-16.54v-2.42h6.84v-2.42h2.8v2.42h6.9zm1.948-14.48h2.64v12.12h-2.64v-12.12zm2.84 17.26h-3.04v-2.98h3.04v2.98z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgTextBalloon);
export default __webpack_public_path__ + "static/media/img_text_balloon.c4fe4a65.svg";
export { ForwardRef as ReactComponent };